const Headings = ({ className = "", text = "", children, variant = "primary" }) => {
  const variantObj = {
    primary: "font-bold text-[20px] leading-[24px] md:text-[32px] md:leading-[42px] lg:leading-[64.96px]",
    secondary: "text-[12px] md:text-[18px] lg:text-[32px] leading-[17px] text-[#00C08B] md:leading-[24px] lg:leading-[40px]",
    tertiary: "font-[500] md:font-[700] text-[16px] md:text-[24px] lg:text-[32px]  leading-[20.96px] md:leading-[28px] lg:leading-[40px] text-[#424952]",
    LoanHeading: "font-Apparat font-[600] md:font-[700] text-[12px] md:text-[16px] tracking-[-2%] text-[#42495240] mt-[12px]",
  }
  return (<h4 className={`font-filson-soft tracking-[-2%] ${variantObj[variant]} ${className}
  `}>
    {children ? children : text}
  </h4>)
}
export default Headings;